import Auth from './auth'
import Vue from 'vue'
import router from './router'
import store from './store'
import VueResource from 'vue-resource'
import App from './App'
import Paginate from 'vuejs-paginate'
import messagesJa from './strings/validator/messages/ja.js'
import VeeValidate from 'vee-validate'
import '@aws-amplify/ui-vue'
import Amplify from 'aws-amplify'
import './styles/settings.scss'

switch (process.env.NODE_ENV) {
  case 'development':
    Amplify.configure({
      Auth: {
        region: process.env.APP_REGION,
        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: process.env.APP_POOL_ID,
        // OPTIONAL - Amazon Cognito Web Client ID
        userPoolWebClientId: process.env.APP_CLIENT_ID
      },
      oauth: {
        // 以下、全てCognitoに設定した情報
        domain: 'auth.dev.alligate.net',
        scope: ['email', 'openid'],
        redirectSignIn: 'https://alliboard.dev.alligate.net',
        redirectSignOut: 'https://alliboard.dev.alligate.net',
        responseType: 'code'
      }
    })
    // Amplify.configure({
    //   Auth: {
    //     // REQUIRED - Amazon Cognito Identity Pool ID
    //     // identityPoolId: 'XX-XXXX-X:XXXXXXXX-XXXX-1234-abcd-1234567890ab',
    //     // REQUIRED - Amazon Cognito Region
    //     region: 'ap-northeast-1',
    //     // OPTIONAL - Amazon Cognito User Pool ID
    //     userPoolId: 'ap-northeast-1_F4tZTfBq1',
    //     // OPTIONAL - Amazon Cognito Web Client ID
    //     userPoolWebClientId: '7rmp0kqtkcfff8cniv2oomsg62'
    //   },
    //   oauth: {
    //     // 以下、全てCognitoに設定した情報
    //     domain: '7da47mkffujxwg964ektnbightwij7.auth.ap-northeast-1.amazoncognito.com',
    //     scope: ['email', 'openid'],
    //     redirectSignIn: 'http://localhost:8080/callback',
    //     redirectSignOut: 'http://localhost:8080/callback',
    //     responseType: 'code'
    //   }
    // })
    break
  case 'staging1':
  case 'staging2':
    //
    Amplify.configure({
      Auth: {
        region: process.env.APP_REGION,
        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: process.env.APP_POOL_ID,
        // OPTIONAL - Amazon Cognito Web Client ID
        userPoolWebClientId: process.env.APP_CLIENT_ID
      },
      oauth: {
        // 以下、全てCognitoに設定した情報
        domain: 'auth.stg.alligate.net',
        scope: ['email', 'openid'],
        redirectSignIn: 'https://alliboard.stg.alligate.net',
        redirectSignOut: 'https://alliboard.stg.alligate.net',
        responseType: 'code'
      }
    })
    break
  case 'production':
    //
    Amplify.configure({
      Auth: {
        region: process.env.APP_REGION,
        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: process.env.APP_POOL_ID,
        // OPTIONAL - Amazon Cognito Web Client ID
        userPoolWebClientId: process.env.APP_CLIENT_ID
      },
      oauth: {
        // 以下、全てCognitoに設定した情報
        domain: 'auth.alligate.net',
        scope: ['email', 'openid'],
        redirectSignIn: 'https://alliboard.alligate.net',
        redirectSignOut: 'https://alliboard.alligate.net',
        responseType: 'code'
      }
    })
    break
  default:
    break
}
Vue.component('paginate', Paginate)
Vue.use(VeeValidate, {
  locale: 'ja',
  dictionary: {
    ja: { custom: messagesJa }
  }
})
Vue.use(VueResource)
Vue.config.productionTip = false
Vue.use(Auth)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  created: function () {
    window.Vue = this
  },
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js